import Items from './itemsContainer';

export default Items;
